const BASE_URL = 'https://finance-app-wallet.herokuapp.com';

export default BASE_URL;
